import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { QfCommonModule } from '@quantium/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './auth/auth.interceptor';

import { HttpErrorInterceptor } from './interceptors/http-error-interceptor/http-error.interceptor';
import { HttpErrorDialogComponent } from './interceptors/http-error-interceptor/http-error-dialog/http-error-dialog.component';
import { LoadingModule } from './loading/loading.module';
import { EndpointsConfigModule } from './endpoints-config/endpoints-config.module';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth/auth.service';
import { MockAuthService } from './auth/mock-auth.service';
import { AUTH_SERVICE } from './auth/auth.token';

@NgModule({
    declarations: [
        AppComponent,
        HttpErrorDialogComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        EndpointsConfigModule.forRoot(),
        TranslateModule.forRoot(),
        QfCommonModule,
        NgbModule,
        LoadingModule,
    ],
    providers: [
        { provide: AUTH_SERVICE, useClass: environment?.mockAuth ? MockAuthService : AuthService },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
